export default "__VITE_ASSET__DnUKm5M7__"